import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';

@Component({
  selector: 'eqp-tour',
  templateUrl: './eqp-tour.component.html',
  styleUrls: ['./eqp-tour.component.scss']
})

export class EqpTourComponent implements OnInit {

  // Traduzioni delle label dei pulsanti
  close: string = this.translate.instant("TOUR.CLOSE");
  next: string = this.translate.instant("TOUR.NEXT");
  back: string = this.translate.instant("TOUR.BACK");
  done: string = this.translate.instant("TOUR.DONE");

  @Input("tourId") tourIdTour: string;

  public guidedTour: GuidedTour = {
    tourId: "",
    steps: [{
      title: "",
      selector: "",
      content: ""
    }]
  };

  constructor(private translate: TranslateService, private tour: GuidedTourService) {
  }

  inizializeTour(tourId: string) {

    if (tourId = "dashboard") {

      this.guidedTour.tourId = this.tourIdTour;

      this.guidedTour.steps = [{
        title: this.translate.instant("TOUR.DASHBOARD"),
        selector: ".dashboard",
        content: this.translate.instant("TOUR.DASHBOARD_CONTENT"),
        orientation: Orientation.Right
      },
      {
        title: this.translate.instant("TOUR.REGISTRY"),
        selector: ".registry",
        content: this.translate.instant("TOUR.REGISTRY_CONTENT"),
        orientation: Orientation.Right
      },
      {
        title: this.translate.instant("TOUR.HELP"),
        selector: ".help",
        content: this.translate.instant("TOUR.HELP_CONTENT"),
        orientation: Orientation.Left
      },
      {
        title: this.translate.instant("TOUR.COMPANY"),
        selector: ".avatar-container",
        content: this.translate.instant("TOUR.COMPANY_CONTENT"),
        orientation: Orientation.Left
      }
      ], this.guidedTour.completeCallback = () => this.tourCompleted(tourId),
        this.guidedTour.skipCallback = () => this.tourCompleted(tourId)
    }
  }

  tourCompleted(tourId) {
    localStorage.setItem(tourId, "true");
  }

  ngOnInit(): void {
    if (localStorage.getItem(this.tourIdTour) != null) {
      return;
    }

    this.inizializeTour(this.tourIdTour);
  }

  startTour() {
    this.tour.startTour(this.guidedTour);
  }

}
